<div mat-dialog-title class="confirm-title">{{ data.title || 'Confirm' }}</div>

<mat-dialog-content class="confirm-content" style="margin: 0px;">
  <div class="confirm-message">{{ data.message }}</div>
</mat-dialog-content>

<mat-dialog-actions align="end" class="confirm-actions">
  <button [attr.guide]="'confirm-yes-no-dialog-btn-1' + '__' + sanitizedUrl" mat-button (click)="cancel()">{{ data.cancelText || 'No' }}</button>
  <button [attr.guide]="'confirm-yes-no-dialog-btn-2' + '__' + sanitizedUrl" mat-flat-button color="primary" (click)="confirm()">{{ data.confirmText || 'Yes' }}</button>
</mat-dialog-actions>
